import { Provider as AppProvider } from 'react-redux';

export default AppProvider;
